/*
 * Used for getting address from postcodes
 */

import axios from 'axios'

const axiosPostcodeAnywhereApi = axios.create({
  baseURL: `${process.env.VUE_APP_PCA_URL}`,
})

axiosPostcodeAnywhereApi.defaults.params = {}
axiosPostcodeAnywhereApi.defaults.params.Key = process.env.VUE_APP_PCA_PUBLIC_KEY

export default axiosPostcodeAnywhereApi
